/* eslint-disable max-len */
import React from "react"

import BaseSvgIcon from "../Base"

const WellnessFill = (props) => (
  <BaseSvgIcon {...props} viewBox="0 0 44 44">
    <path
      d="M15.8698 14.27C14.4498 12.99 13.1798 12.23 12.5498 11.89C12.3298 11.77 12.0598 11.89 11.9898 12.12C11.7698 12.81 11.3798 14.29 11.2498 16.24C11.2398 16.4 11.3298 16.55 11.4698 16.62C12.4498 17.09 13.4498 17.66 14.4598 18.37C14.6998 18.54 15.0198 18.4 15.0798 18.11C15.2998 16.87 15.6098 15.73 15.9798 14.7C16.0298 14.55 15.9798 14.38 15.8698 14.28V14.27Z"
      fill="#000"
    />
    <path
      d="M32.7501 16.23C32.6201 14.28 32.2301 12.81 32.0201 12.11C31.9501 11.87 31.6801 11.76 31.4601 11.88C30.8301 12.22 29.5501 12.99 28.1301 14.27C28.0101 14.38 27.9701 14.54 28.0201 14.69C28.3801 15.73 28.7001 16.87 28.9201 18.1C28.9701 18.39 29.3001 18.52 29.5401 18.36C30.5501 17.65 31.5601 17.08 32.5401 16.6C32.6801 16.53 32.7701 16.38 32.7601 16.22L32.7501 16.23Z"
      fill="#000"
    />
    <path
      d="M14.6399 22.1598C10.4099 18.2998 5.60986 17.5498 4.11986 17.3998C3.86986 17.3798 3.66986 17.5798 3.68986 17.8298C3.84986 19.3898 4.67986 24.5898 8.98986 28.8998C11.9999 31.9098 15.3899 33.1998 17.6799 33.7598C18.0299 33.8498 18.2999 33.4598 18.1099 33.1598C17.4299 32.0898 16.2699 30.0198 15.5199 27.3398C14.8499 24.9398 14.7699 23.0098 14.7599 22.4398C14.7599 22.3298 14.7099 22.2298 14.6299 22.1498L14.6399 22.1598Z"
      fill="#000"
    />
    <path
      d="M29.3599 22.1598C33.5899 18.2998 38.3899 17.5498 39.8799 17.3998C40.1299 17.3798 40.3299 17.5798 40.3099 17.8298C40.1499 19.3898 39.3199 24.5898 35.0099 28.8998C31.9999 31.9098 28.6099 33.1998 26.3199 33.7598C25.9699 33.8498 25.6999 33.4598 25.8899 33.1598C26.5699 32.0898 27.7299 30.0198 28.4799 27.3398C29.1499 24.9398 29.2299 23.0098 29.2399 22.4398C29.2399 22.3298 29.2899 22.2298 29.3699 22.1498L29.3599 22.1598Z"
      fill="#000"
    />
    <path
      d="M22.3098 10.1402C22.1498 9.94023 21.8498 9.94023 21.6898 10.1402C20.6698 11.3902 17.5098 15.7702 17.5098 22.0202C17.5098 28.2702 20.6798 32.6202 21.6998 33.8502C21.8598 34.0502 22.1598 34.0502 22.3198 33.8502C23.3398 32.6202 26.5098 28.2702 26.5098 22.0202C26.5098 15.7702 23.3398 11.3902 22.3298 10.1402H22.3098Z"
      fill="#000"
    />
  </BaseSvgIcon>
)

export default WellnessFill
